// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"OrderDeliveryNotice_useFade-fadeIn__tqmq6","useFade-fadeOut":"OrderDeliveryNotice_useFade-fadeOut__P22Ja"};